import {PinProtect} from '~/features/Auth/PinProtect';
import {UserListLookup} from '~/features/UserLookup/UserListLookup/UserListLookup';

export const UserListLookupScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <PinProtect>
        <UserListLookup />
      </PinProtect>
    </div>
  );
};
